export const ADD_APPLICATION_DATA = "ADD_APPLICATION_DATA"